// extracted by mini-css-extract-plugin
export default {"container":"fQs70JAGPjc-sH4kGUicpw==","image":"WTy3nSTcu54oKBFwz4R4Pw==","textContainer":"_0cUXOkLsG5s8I35Lv0rbMQ==","qontoHeader":"QsfjYtnRPC9+MUYnF2mv5g=="};